import { useEffect, useRef } from 'react';
import type { Chart as ChartJS } from 'chart.js';

/**
 * Returns a ref for react-chartjs-2 components that triggers a "reset"
 * animation each time `isVisible` flips to true.
 */
export function useChartReveal(isVisible: boolean) {
  const chartRef = useRef<ChartJS | null>(null);

  useEffect(() => {
    const chart = chartRef.current;
    if (!chart) return;
    if (isVisible) {
      // Ensure we restart the animation from baseline.
      chart.stop();
      chart.update('reset');
    }
  }, [isVisible]);

  return chartRef;
}

export default useChartReveal;
